// @ts-check
import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';

const UserSummary = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
  created_at: Timestamp,
  updated_at: Timestamp,
  user_last_login: Timestamp,
  company_id: z.number(),
  language: z.string(),
  language_hint_ignored: z.boolean(),
  role: z.enum(['user', 'admin', 'super-admin']),
});

export default UserSummary;
